export default __webpack_public_path__ + "static/media/IkonVaekstSort.6d15d948.svg";